
import Vue from 'vue';

export default Vue.extend({
  name: 'FaqModule',
  data() {
    return {
      openIdx: 0,
      qaList: [
        {
          question: '极速支付扣的哪里的钱（或怎么调整扣款顺序）？',
          answer:
            '极速支付支持余额、银行卡、美团月付等美团支付方式，最终扣款方式将根据你的实际可用支付方式及扣款顺序而定。我们将根据你的支付习惯生成极速支付的默认扣款顺序，同时还提供多种扣款顺序方案，比如自定义排序、支付优惠排序等。具体扣款方式可在「我的钱包」-「设置」-「极速支付」-「扣款顺序」设置页手动调整。',
        },
        {
          question: '不输入支付密码就扣款安全吗？',
          answer:
            '极速支付是一款极简的支付产品，不需要支付密码的背后是大数据智能风控在保驾护航。我们会通过对支付环境的监测和账户的使用习惯，实时决策当前使用是否有风险，加上资金被盗即赔，共同保障了账户的使用和资金安全。',
        },
        {
          question: '极速支付有支付金额和次数的限制吗？',
          answer:
            '极速支付单笔支付限额最高为1000元，用户可自行设置单笔支付限额档位，超过当笔支付限额后需进行调额，否则无法继续使用极速支付，极速支付不限制使用次数，但当系统检测到支付环境有风险因素时，可能会暂时限制使用极速支付。',
        },
        {
          question: '在支付某些订单时，我临时不想使用极速支付怎么办？',
          answer:
            '你可以在提单页将你的支付方式切换为「普通支付」，就可以正常进入收银台完成支付了。',
        },
      ],
    };
  },
  methods: {
    handleClick(idx: number) {
      if (this.openIdx !== idx) {
        this.openIdx = idx;
        this.$emit('change', idx, this.qaList[idx]);
      } else {
        this.openIdx = -1;
      }
    },
  },
});
